/** An entry's approval status, readable without opening it (P1-TR3). */

import { useTranslation } from '../../i18n/useTranslation.js';
import type { Transaction } from './api.js';

const STATUS_STYLE: Record<Transaction['status'], string> = {
  pending: 'bg-amber-100 text-amber-900',
  approved: 'bg-green-100 text-green-900',
  rejected: 'bg-red-100 text-red-900',
  voided: 'bg-gray-200 text-gray-700',
};

export function StatusBadge({ status }: { status: Transaction['status'] }): JSX.Element {
  const { t } = useTranslation();

  return (
    <span className={`rounded-full px-2 py-0.5 text-xs font-medium ${STATUS_STYLE[status]}`}>
      {t(`finance.status.${status}`)}
    </span>
  );
}
